import React from "react";
import "./Webdesign.css";
import static_website from "./Services/webdesign-hero.jpeg";
import dynamic_website from "./Services/webdesign1.jpg";
import web_app from "./Services/webdesign2.jpg";
import { Helmet } from "react-helmet-async";
import Banner from "../../Banner/Banner";

const WebdesignPage = () => {
  return (
    <>
      <Helmet>
        <title> Website Design & Development for Business </title>
        <meta
          name="description"
          content="We offer website design and development services that create responsive, user-friendly and SEO-ready websites to support better business growth online."
        />
        <meta
          name="keywords"
          content="Website design, Portfolio website, Ecommerce website, Website builder, Landing page, UI design, UX design, Website development, Business website, Web solutions, Corporate website "
        />
        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/website-design-development" />
        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/website-design-development" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/website-design-development" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/website-design-development" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/website-design-development" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/website-design-development" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/website-design-development" />

      </Helmet>
      <Banner image={static_website} alt="Website Design and Development" />

      <div className="content_lists">
        <div className="product_cont">
          <div className="career_p">
            <h1 className="product_title">Professional Website Design & Development</h1>
            <p className="cont_para_style">
              If you are a business owner unsure about choosing the right website development
              provider, KitKat Software Technologies is here to guide you. Our highly experienced
              developers design and develop professional websites that align perfectly with your
              business goals and brand vision. We focus on creating impactful digital experiences that
              help your business stand out in today’s competitive online market.
            </p>

            <div className="img_pro">
              <img
                src={dynamic_website}
                width="100%"
                height="100%"
                alt="Static Website"
                style={{ objectFit: "cover" }}
              />
            </div>
            <p className="cont_para_style">
              We specialize in building websites based on detailed research and strategic planning.
              Before starting any project, our team carefully analyzes your business model, target
              audience, industry trends, and competitors. This approach allows us to create fully
              customized websites that reflect your mission, objectives, and unique value proposition.
              Our goal is not just to build a website, but to develop a strong online presence that
              drives engagement and growth.
              {" "}
            </p>

            <p className="cont_para_style">
              We design and develop all types of websites, including static websites for simple
              information display, dynamic websites for interactive functionality, and feature-rich
              e-commerce platforms for online selling. Each website is built with a responsive design,
              user-friendly interface, and optimized performance to ensure smooth browsing across
              all devices.
            </p>
            <p className="cont_para_style">
              At KitKat Software Technologies, we provide scalable and customized website solutions
              that support long-term business growth. Partner with us to transform your ideas into a
              powerful digital platform that delivers real results.
            </p>
            <div className="img_pro">
              <img
                src={web_app}
                width="100%"
                height="100%"
                alt="Dynmaic Website"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default WebdesignPage;
